module.exports = __webpack_public_path__ + "static/media/user-solid.eafca1fd.svg";